import { ActivityTrace } from "@models/job.model";
import { httpRequest } from "../../http";

export class CommandGetJobLogs {
  async run(jobId: number): Promise<ActivityTrace[]> {
    try {
      const request = await httpRequest<ActivityTrace[]>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/jobs/${jobId}/logs/`,
        {
          method: "GET",
        }
      );
      return request ?? [];
    } catch (error) {
      // Fallback path — degrade to empty so the UI shows "No activities yet"
      // rather than throwing (proxy may be disabled or the job too old).
      console.error("Error fetching job logs:", error);
      return [];
    }
  }
}
